import { Checkbox, Icon } from '@mairistem/composants';
import { ListeTable } from '@mairistem/liste';
import _ from 'lodash';
import React from 'react';

import type { RegieRegisseurType } from '@/types';
import { ModalRegisseur } from './ModalRegisseur';

interface RegieMandataireListeTableRowProps {
  item: RegieRegisseurType;
  rowProps: Record<string, unknown>;
  onRegisseurEdit: (regisseur: RegieRegisseurType) => void;
  onRegisseurRemove: (regisseur: RegieRegisseurType) => void;
}

const RegieMandataireListeTableRow = (props: RegieMandataireListeTableRowProps) => {
  const { item, rowProps, onRegisseurEdit, onRegisseurRemove } = props;

  const { identifiant, nom, prenom, mandat = 'Régisseur suppléant', actif = false } = item;

  const [editModal, setEditModal] = React.useState(false);

  const handleEditClick = React.useCallback(() => {
    setEditModal(true);
  }, []);

  const handleSave = React.useCallback(
    (regisseur) => {
      onRegisseurEdit({
        ...item,
        ...regisseur,
      });

      setEditModal(false);
    },
    [item, onRegisseurEdit],
  );

  const handleRemove = React.useCallback(
    (regisseur) => {
      onRegisseurRemove(regisseur);

      setEditModal(false);
    },
    [onRegisseurRemove],
  );

  return (
    <ListeTable.Row key={identifiant} {...rowProps}>
      <ListeTable.Cell
        name="nom"
        // @ts-expect-error
        title={_.trim(`${nom || ''} ${prenom || ''}`)}
      >
        {_.trim(`${nom || ''} ${prenom || ''}`)}
        <Icon
          data-testid="regie-mandataires-icon-edit"
          link
          name="pencil"
          className="liste-table-row-icon"
          onClick={handleEditClick}
          title="Modifier le régisseur ou le mandataire"
        />
        {editModal && (
          <ModalRegisseur
            regisseur={item}
            onSave={handleSave}
            onRemove={handleRemove}
            onClose={() => setEditModal(false)}
          />
        )}
      </ListeTable.Cell>
      <ListeTable.Cell
        name="mandat"
        // @ts-expect-error
        title={mandat}
      >
        {mandat}
      </ListeTable.Cell>
      <ListeTable.Cell
        name="actif"
        // @ts-expect-error
        title="Actif ou non actif"
        textAlign="center"
      >
        <Checkbox checked={actif} disabled />
      </ListeTable.Cell>
    </ListeTable.Row>
  );
};

export default RegieMandataireListeTableRow;
